import axios from "axios";
var base64 = require('base-64');

var userId = null;

function getauth() {
    userId = localStorage.Cookies ? JSON.parse(localStorage.Cookies).userId : null;
    var authorization_value = null;
    if (userId)
        authorization_value = "Basic " + base64.encode(encodePassword(userId) + ":");
    return authorization_value;
}

const instance = axios.create({
    // baseURL: 'http://localhost:5000/',
    headers: { 
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
    },
});

/**
 * Actions 
*/

export function setToolId(data) {
    return {
        type: "SET_TOOLID",
        payload: data
    }
};

export function setTableData(data) {
    return {
        type: "SET_TABLEDATA",
        payload: data
    }
};

export function setRawDataFilter(data) {
    return {
        type: "SET_DATA_FILTER",
        payload: data
    }
};


export function getToolId(data) {
    return {
        type: "GET_TOOLID",
    }
};

export function setConnectionType(data) {
    return {
        type: "SET_CONNECTION_TYPE",
        payload: data
    }
};


export function getConnectionType(data) {
    return {
        type: "GET_CONNECTION_TYPE",
    }
};


export function getDataSet(dataSet) {
    return function (dispatch) {
        instance.get('/api/data', {
            headers: {
                Authorization: getauth()
            },
            params: {
                siteId: dataSet.siteId,
                toolId: dataSet.toolId
            }
        }).then(res => {
            dispatch({
                type: "GET_DATA",
                payload: res.data
            })
        }).catch(err => {
            dispatch({
                type: "GET_DATA",
                payload: []
            })
        })
    }
};





